import SimpleCrud from "./SimpleCrud";

const EMPTY = { company_name: "", contact_name: "", phone: "", email: "", address: "", notes: "" };
const FIELDS = [
  { key: "company_name", label: "Company" },
  { key: "contact_name", label: "Contact" },
  { key: "phone", label: "Phone" },
  { key: "email", label: "Email" },
  { key: "address", label: "Address" },
  { key: "notes", label: "Notes", textarea: true },
];

export default function Customers() {
  return <SimpleCrud title="Customers" endpoint="customers" testid="customers-admin" empty={EMPTY} fields={FIELDS} />;
}
